import { CheckIcon, Pencil, Plus, RefreshIcon } from 'assets/icons';
import { dayLabel, durationLabel, fromIsoDay } from 'helper/timeLabels';

const ICONS = {
  created: <Plus wh={15} color="currentColor" />,
  done: <CheckIcon w={14} h={11} color="currentColor" />,
  reopened: <RefreshIcon wh={15} color="currentColor" />,
  updated: <Pencil wh={15} color="currentColor" />,
};
const nameOf = (person) => (person ? `${person.firstname} ${person.lastname}`.trim() : '');
const excerpt = (value) => `« ${String(value).slice(0, 80)}${String(value).length > 80 ? '…' : ''} »`;

/**
 * The timeline of a task's panel (components/activity/ActivityTimeline), from
 * its history (crmApi.getTaskActivity), the newest first: its creation, its
 * changes field by field, done or reopened. `labels`: `text` (taskActivity.*),
 * `typeLabel`, the `team` and the `companies` to name the ids, the task's
 * `creator` (createdByPerson).
 */
const taskActivityItems = (events, { text, typeLabel, team, companies, creator }) => {
  const person = (id) => nameOf(team.find((member) => member.id === id));
  const shown = (field, value) => {
    // A task assigned to no one stays with whoever created it.
    if (field === 'assigneeId' && !value) return nameOf(creator) || text('someone');
    if (value === null || value === '' || value === undefined) return text('empty');
    if (field === 'dueOn') return dayLabel(fromIsoDay(value)).toLowerCase();
    if (field === 'dueTime') return String(value).slice(0, 5);
    if (field === 'durationMin') return durationLabel(Number(value));
    if (field === 'type') return typeLabel(value);
    if (field === 'assigneeId') return person(value) || text('someone');
    if (field === 'companyId') return companies.find((item) => item.companyId === value)?.company ?? text('otherCompany');
    if (field === 'note' || field === 'emailBody') return excerpt(value);
    return String(value);
  };
  const linksShown = (list) => (list?.length ? list.map((link) => link.label).join(', ') : text('empty'));
  return events
    .map((event) => {
      const by = nameOf(event.actor);
      const lines = Object.entries(event.changes ?? {}).map(([field, change]) => {
        // The links change as { from, to }, lists of views; the others as [before, after].
        if (field === 'links') {
          return `${text('field_links')} : ${linksShown(change.from)} → ${linksShown(change.to)}`;
        }
        const [before, after] = change;
        return `${text(`field_${field}`)} : ${shown(field, before)} → ${shown(field, after)}`;
      });
      return {
        id: event.id,
        icon: ICONS[event.kind] ?? ICONS.updated,
        at: new Date(event.at),
        text: by ? text(`${event.kind}By`, { name: by }) : text(event.kind),
        lines,
      };
    })
    .sort((a, b) => b.at - a.at);
};

export default taskActivityItems;
